import { Injectable } from '@angular/core';
import { Constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getLanguage(): string {
    const lang = localStorage.getItem(Constants.lang);
    if (!lang) {
      return Constants.defaultLang;
    }
    return JSON.parse(lang);
  }

  setLanguage(lang: string) {
    const json = JSON.stringify(lang);
    localStorage.setItem(Constants.lang, json);
  }

  getIsSelectedAdminMode(): boolean {
    const lang = localStorage.getItem(Constants.isSelectedAdminMode);
    return JSON.parse(lang);
  }

  setIsSelectedAdminMode(data: boolean) {
    const json = JSON.stringify(data);
    localStorage.setItem(Constants.isSelectedAdminMode, json);
  }

  getLastViewedPage(): string {
    const lang = localStorage.getItem(Constants.currentPage);
    return JSON.parse(lang);
  }

  setLastViewedPage(data: string) {
    if (!data || data.includes(Constants.loginPage)) {
      return;
    }
    const json = JSON.stringify(data);
    localStorage.setItem(Constants.currentPage, json);
  }

  setLogoutState() {
    localStorage.setItem(Constants.logoutState, 'true');
  }

  getLogoutState(): boolean {
    const logoutState = localStorage.getItem(Constants.logoutState);
    if (!logoutState) {
      return false
    }
    return JSON.parse(logoutState);
  }

  clearLogoutState() {
    localStorage.removeItem(Constants.logoutState);
  }
}
